/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiUpdateStationConfigMutationRequest, ContentAiUpdateStationConfigMutationResponse, ContentAiUpdateStationConfigPathParams, ContentAiUpdateStationConfig401, ContentAiUpdateStationConfig403 } from "../models/ContentAiUpdateStationConfig";

export function getContentAiUpdateStationConfigUrl(stationId: ContentAiUpdateStationConfigPathParams["stationId"]) {
  const res = { method: 'PUT', url: `/content-ai/v1/station-config/${stationId}` as const }
  return res
}

/**
 * @summary Update station config
 * {@link /content-ai/v1/station-config/:stationId}
 */
export async function contentAiUpdateStationConfig(stationId: ContentAiUpdateStationConfigPathParams["stationId"], data: ContentAiUpdateStationConfigMutationRequest, config: Partial<RequestConfig<ContentAiUpdateStationConfigMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiUpdateStationConfigMutationResponse, ResponseErrorConfig<ContentAiUpdateStationConfig401 | ContentAiUpdateStationConfig403>, ContentAiUpdateStationConfigMutationRequest>({ method : "PUT", url : getContentAiUpdateStationConfigUrl(stationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}